<template>
  <div>
    <h5 class="login-box-msg"><b>Sign In</b></h5>
    <div class="input-group mb-3">
      <input type="text" v-model="USR" class="form-control" placeholder="Username">
      <div class="input-group-append">
        <div class="input-group-text">
          <span class="fas fa-envelope"></span>
        </div>
      </div>
    </div>
    <div class="input-group mb-3">
      <input type="password" v-model="PSW" class="form-control" placeholder="Password">
      <div class="input-group-append">
        <div class="input-group-text">
          <span class="fas fa-lock"></span>
        </div>
      </div>
    </div>
    <div class="input-group mb-3">
      <input type="text" v-model="USR_BRANCHID" v-on:input="restrictBranchCode" class="form-control" placeholder="Branch Code">
      <div class="input-group-append">
        <div class="input-group-text">
          <span class="fas fa-code-branch"></span>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="g-recaptcha" data-sitekey="6LeVlaUnAAAAAJVJFKfPWMsA5CQPy9RM6h-S8e7c"></div>
    </div>
    <div class="row">
      <div class="col-8">
        <div class="icheck-primary">
          <input type="checkbox" id="remember">
          <label for="remember">Remember Me</label>
        </div>
      </div>
      <div class="col-4">
        <button v-on:click="submitForm" class="btn btn-primary btn-block" type="button">Sign In</button>
      </div>
    </div>
    <p class="mb-1 mt-3">
      <a href="#" class="text-primary">I forgot my password</a>
    </p>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    data() {
      return {
        USR: '',
        PSW: '',
        USR_BRANCHID: '',
        errorMessage: '',
        ReturnUrl:"",
      };
    },
    mounted() {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        grecaptcha.render('g-recaptcha', {
          'sitekey': '6LeVlaUnAAAAAJVJFKfPWMsA5CQPy9RM6h-S8e7c'
        });
      };
      document.head.appendChild(script);
    },
    created() {
      this.pageLoad();
    },
    methods: {
      restrictBranchCode() {
        this.USR_BRANCHID = this.USR_BRANCHID.replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);
      },
      pageLoad() {
        const param = new URLSearchParams(window.location.search);
        this.ReturnUrl = param.get("ReturnUrl");
        console.log(this.ReturnUrl);
      },
      submitForm() {
        var vm = this;
        startReq();
        axios.post("/api/AccountApi/Login", {
          USR: vm.USR,
          PSW: vm.PSW,
          USR_BRANCHID: vm.USR_BRANCHID,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success(res.data.msg);
              if (vm.ReturnUrl == null) {
                window.location.href = res.data.ReturnUrl;
              }
              else {
                window.location.href = vm.ReturnUrl;
              }
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      }
    }
  };
</script>

<!--<style scoped>
  .login-box {
    width: 360px;
    margin: 1% auto;
  }

  .error-message {
    color: red;
    font-size: 0.9em;
  }
</style>-->
<style scoped>
  .login-box {
    width: 360px;
    margin: 1% auto;
    background: #fff;
    padding: 20px;
    border-radius: 10px;
    position: relative;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2), -5px -5px 10px rgba(255, 255, 255, 0.8), inset 2px 2px 5px rgba(0, 0, 0, 0.1), inset -2px -2px 5px rgba(255, 255, 255, 0.7);
  }

    .login-box::before {
      content: '';
      position: absolute;
      top: -4px;
      left: -4px;
      right: -4px;
      bottom: -4px;
      border-radius: 12px;
      background: linear-gradient(45deg, #f3f3f3, #ffffff);
      z-index: -1;
    }

    .login-box::after {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border-radius: 11px;
      background: linear-gradient(45deg, #ffffff, #e6e6e6);
      z-index: -1;
    }

  .input-group {
    transition: all 0.3s ease;
  }

    .input-group:hover {
      transform: translateY(-2px);
      box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);
    }

  .form-control {
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #f8f9fa;
  }

  .btn-primary {
    background: linear-gradient(to right, #007bff, #0056b3);
    border: none;
    border-radius: 4px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
  }

    .btn-primary:hover {
      transform: translateY(-2px);
      box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.3);
    }

  .error-message {
    color: red;
    font-size: 0.9em;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/Login.vue